import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { UserApi, UserBilan } from 'src/app/models/api_models/user';
import { PageConfigService } from 'src/app/page-config.service';
import { UserApiService } from 'src/app/user-api.service';

@Component({
  selector: 'app-user-formula',
  templateUrl: './user-formula.component.html',
  styleUrls: ['./user-formula.component.scss']
})



export class UserFormulaComponent implements OnInit {
  constructor(public domSanitizer: DomSanitizer, private PageConfigService: PageConfigService,
     private userApiService: UserApiService, public translate: TranslateService)
   { 

     

   }
  currentUser: UserBilan = undefined;
  isLoad: boolean = false;
  beginningDate: Date = new Date();

  public translate_fr = { "prepaid": "Prépaiement", "paydebit": "Prélèvement", "direct": "Paiement CB", "transfer": "Virement" };
  public translate_es = { "prepaid": "Pago anticipado", "paydebit": "Domiciliación bancaria", "direct": "Pago con tarjeta de crédito", "transfer": "Transferencia" };
  public translate_en = { "prepaid": "Prepayment", "paydebit": "Direct debit", "direct": "Credit card payment", "transfer": "Bank transfer" };
  public translate_ca = { "prepaid": "Prepagament", "paydebit": "Domiciliació", "direct": "Pagament amb targeta de crèdit", "transfer": "Transferència bancària" };

  img = "";
  public getUserImg() {
  }

  microTranslate
  urlInform : any

  ngOnInit() {
    // this.img = "data:"+this.curr.mimetype+";base64, "+this.stationDetail.detail.image.file;
    // this.userApiService.getCurrentUserData().subscribe(response => {
    //   this.currentUser = response;
    //   console.warn(response);
    //   console.log(response);

    // },
    // error => {
    //   console.error(error);
    // })

    let lang = this.translate.currentLang;

    this.microTranslate = this.translate_ca


    switch (this.translate.currentLang) {
      case 'fr':
        this.microTranslate = this.translate_fr
        break;
      case 'en':
        this.microTranslate = this.translate_en
        break;
      case 'es':
        this.microTranslate = this.translate_es
        break;
      case 'ca':
        this.microTranslate = this.translate_ca
        break;
      default:
        this.microTranslate = this.translate_fr
    }



    this.userApiService.getUserDetail().subscribe(response => {

      this.currentUser = response;
      this.beginningDate = new Date(this.currentUser.contract.beginning);

      this.isLoad = true;
    },
      error => {
        console.error(error);
      }
    )
  }



 getUrlInform(territory) {
  return `https://subscribe.clem.mobi/inform/communautes?territory=${territory.id}`
}

}
